export const PAGINATION_OUTLET_NODE_ID = "pagination-outlet";
export const PROPOSALS_ACTIONS_OUTLET_NODE_ID = "proposals-actions-outlet";

export const PAGINATION_DEFAULT_PAGE_SIZE = 25;
export const PAGINATION_DEFAULT_PAGE_NUMBER = 0;

export const PLACEHOLDER_SIGN = "-";
